import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cswitch(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
         <Sides/>
        <Helmet>
 
 <title>C Switch Statement tutorial For Beginners</title>
 <meta name="description" content="Switch in C tutorial for beginners.switch case in c used in multiple conditions having different statements like-if else if,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,learn code in free,c programming tutorial for beginners,learn code in free online,switch case in c,c case statement,c switch statement,c switch case,c switch case example,c switch on string,c switch string,c programming switch statement,c programming switch case,c switch example,c switch default,switch c language,c switch case string,c switch statement string,c language switch case" />
 <link rel="canonical" href="https://www.codeexampler.com/c-switch" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">C switch Statement</h1>
    <div className="first">
        <a href="/c-if-else-if">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-looping">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">The Switch statement in c:</h2>
    <p className="mt-4 para">Switch case in c used in multiple conditions having different statements like-if if but it can check only equality of the floating condition point but value can’t check by the switch.</p>
  

<h2 className='headings'>The Syntax for Switch Statement in C:</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
          {"\n"}
                <span className="qwerty-6">switch </span>
                <span className="qwerty-4">(</span>            
                <span className="qwerty-10">variable</span>
                <span className="qwerty-4">)</span>            
                        {"\n"}   
                        <span className="qwerty-4" > &#123; </span>             
                        {"\n"}
                <span className="qwerty-3">   case </span>
                <span className="qwerty-1">1</span>
                <span className="qwerty-4">:</span>            
            {"\n"}               
                <span className="qwerty-2">   statement</span>
                <span className="qwerty-4">;</span>
            {"\n"}
                <span className="qwerty-3">   case </span>
                <span className="qwerty-1">2</span>
                <span className="qwerty-4">:</span>            
            {"\n"}               
                <span className="qwerty-2">   statement</span>
                <span className="qwerty-4">;</span>
            {"\n"}
                <span className="qwerty-3">   default</span>
                <span className="qwerty-4">:</span>            
            {"\n"}               
                <span className="qwerty-2">   statement</span>
                <span className="qwerty-4">;</span>
            {"\n"}
                <span className="qwerty-4"> &#125;</span>
                {"\n"}      {"\n"} 
                 </code>
        </pre>
        </div>
           
 


<p className="mt-4 para">In this keyword switch inside c programming that will yield an integer value, forex-case1,case2, etc. this is an integer constant<br/>
if you do not find any match in this condition case statements so on that time default statement is executed
</p>

   
<h2 className='headings'>Q-Write a program to input a no and print month name, and if no is 2 but without a break?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
          {"\n"}
          <span className="qwerty-7">#include </span>
                <span className="qwerty-4">&#60;</span>
                <span className="qwerty-10">stdio.h</span>
                <span className="qwerty-4">&#62; </span>
                        {"\n"}
                <span className="qwerty-3">int </span>
                <span className="qwerty-2">main</span>
                <span className="qwerty-4"> ()</span>            
                        {"\n"}   
                        <span className="qwerty-4" > &#123; </span>             
                        {"\n"}
                <span className="qwerty-3">   int </span>
                <span className="qwerty-5">i</span>
                <span className="qwerty-4">;</span>            
            {"\n"}               
            <span className="qwerty-8">   printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2"> Enter a number </span>
                <span className="qwerty-4">");</span>
            {"\n"}
            <span className="qwerty-6">   scanf</span>
            <span className="qwerty-4">("</span>
            <span className="qwerty-3">%d</span>
            <span className="qwerty-4">",</span>
            <span className="qwerty-1"> &amp;</span>
            <span className="qwerty-5">i </span>
            <span className="qwerty-4">);</span>
                   {"\n"}     
                <span className="qwerty-6">   switch </span>
                <span className="qwerty-4">(</span>
                <span className="qwerty-5">i</span>
                <span className="qwerty-4">) </span>
            {"\n"}
                <span className="qwerty-4" >   &#123; </span>
            {"\n"}          
            <span className="qwerty-3">    case </span>
                <span className="qwerty-1">1</span>
                <span className="qwerty-4">:</span>            
            {"\n"}
            <span className="qwerty-8">    printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">Jan \n</span>
                <span className="qwerty-4">");</span>
            {"\n"}
            <span className="qwerty-3">    case </span>
                <span className="qwerty-1">2</span>
                <span className="qwerty-4">:</span>            
            {"\n"}
            <span className="qwerty-8">    printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">Feb \n</span>
                <span className="qwerty-4">");</span>
            {"\n"}
            <span className="qwerty-3">    case </span>
                <span className="qwerty-1">3</span>
                <span className="qwerty-4">:</span>            
            {"\n"}
            <span className="qwerty-8">    printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">March \n</span>
                <span className="qwerty-4">");</span>
            {"\n"}
            <span className="qwerty-3">    default</span>
                <span className="qwerty-4">:</span>            
            {"\n"}
            <span className="qwerty-8">    printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">Default</span>
                <span className="qwerty-4">");</span>
            {"\n"}                     
                  <span className="qwerty-4" >   &#125;</span>       
            {"\n"}                   
            <span className="qwerty-7">   return</span>
                <span className="qwerty-3"> 0</span>
                <span className="qwerty-4">; </span>
            {"\n"}            
                <span className="qwerty-4"> &#125;</span>
                {"\n"}      {"\n"} 
                 </code>
        </pre>
        </div>
        <h4 className='headings'>Output :</h4>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
          <pre style={{maxHeight:"100vh"}}>
                <code >                  
                {"\n"}      
                  <span className="qwerty-5">Enter a number</span>                   
                  <span className="qwerty-1"> 2</span>                   
                  {"\n"}                
                  <span className="qwerty-3">Feb</span>
                  {"\n"}                   
                  <span className="qwerty-3">March</span>                   
                  {"\n"}
                  <span className="qwerty-3">Default</span>                   
                  {"\n"}   {"\n"} 
                  </code>
                  </pre>
                  </div>  


   <p className="mt-4 para">This program gives output but is not what we expected because we did not provide case 3 and default values.</p>
<h2 className="mt-4 mh2"> Break switch statement:</h2>
<p className="mt-4 para">If you want to give the only <span className="bold"> case 2</span> statement so using break statement</p>

   


   
<h2 className='headings'>Q-Write a program to input a no and print month name, and if no is 2,use a break?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
          {"\n"}
          <span className="qwerty-7">#include </span>
                <span className="qwerty-4">&#60;</span>
                <span className="qwerty-10">stdio.h</span>
                <span className="qwerty-4">&#62; </span>
                        {"\n"}
                <span className="qwerty-3">int </span>
                <span className="qwerty-2">main</span>
                <span className="qwerty-4"> ()</span>            
                        {"\n"}   
                        <span className="qwerty-4" > &#123; </span>             
                        {"\n"}
                <span className="qwerty-3">   int </span>
                <span className="qwerty-5">i</span>
                <span className="qwerty-4">;</span>            
            {"\n"}               
            <span className="qwerty-8">   printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2"> Enter a number </span>
                <span className="qwerty-4">");</span>
            {"\n"}
            <span className="qwerty-6">   scanf</span>
            <span className="qwerty-4">("</span>
            <span className="qwerty-3">%d</span>
            <span className="qwerty-4">",</span>
            <span className="qwerty-1"> &amp;</span>
            <span className="qwerty-5">i </span>
            <span className="qwerty-4">);</span>
                   {"\n"}     
                   {"\n"}     
                <span className="qwerty-6">   switch </span>
                <span className="qwerty-4">(</span>
                <span className="qwerty-5">i</span>
                <span className="qwerty-4">) </span>
            {"\n"}
                <span className="qwerty-4" >   &#123; </span>
            {"\n"}          
            <span className="qwerty-3">    case </span>
                <span className="qwerty-1">1</span>
                <span className="qwerty-4">:</span>            
            {"\n"}
            <span className="qwerty-8">    printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">Jan \n</span>
                <span className="qwerty-4">");</span>
            {"\n"}
            <span className="qwerty-5">    break</span>
                <span className="qwerty-4">;</span>            
            {"\n"}
            <span className="qwerty-3">    case </span>
                <span className="qwerty-1">2</span>
                <span className="qwerty-4">:</span>            
            {"\n"}
            <span className="qwerty-8">    printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">Feb \n</span>
                <span className="qwerty-4">");</span>
            {"\n"}
            <span className="qwerty-5">    break</span>
                <span className="qwerty-4">;</span>            
            {"\n"}
            <span className="qwerty-3">    case </span>
                <span className="qwerty-1">3</span>
                <span className="qwerty-4">:</span>            
            {"\n"}
            <span className="qwerty-8">    printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">March \n</span>
                <span className="qwerty-4">");</span>
            {"\n"}
            <span className="qwerty-5">    break</span>
                <span className="qwerty-4">;</span>            
            {"\n"}
            <span className="qwerty-3">    default</span>
                <span className="qwerty-4">:</span>            
            {"\n"}
            <span className="qwerty-8">    printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">Default</span>
                <span className="qwerty-4">");</span>
            {"\n"}                     
                  <span className="qwerty-4" >   &#125;</span>       
            {"\n"}                   
            <span className="qwerty-7">   return</span>
                <span className="qwerty-3"> 0</span>
                <span className="qwerty-4">; </span>
            {"\n"}            
                <span className="qwerty-4"> &#125;</span>
                {"\n"}      {"\n"} 
                 </code>
        </pre>
        </div>
        <h4 className='headings'>Output :</h4>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
          <pre style={{maxHeight:"100vh"}}>
                <code >                  
                {"\n"}      
                  <span className="qwerty-10">Enter a number</span>                   
                  <span className="qwerty-1"> 2</span>                   
                  {"\n"}                
                  <span className="qwerty-3">Feb</span>
                     {"\n"} 
                     {"\n"} 
                  </code>
                  </pre>
                  </div> 



   
<h2 className='headings'>Q-Write a program  input without user type I in switch in switch case char Values?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
          {"\n"}
          <span className="qwerty-7">#include </span>
                <span className="qwerty-4">&#60;</span>
                <span className="qwerty-10">stdio.h</span>
                <span className="qwerty-4">&#62; </span>
                        {"\n"}
                <span className="qwerty-3">int </span>
                <span className="qwerty-2">main</span>
                <span className="qwerty-4"> ()</span>            
                        {"\n"}   
                        <span className="qwerty-4" > &#123; </span>             
                        {"\n"}
                <span className="qwerty-3">   int </span>
                <span className="qwerty-5">i</span>
                <span className="qwerty-4">=</span>            
                <span className="qwerty-1">20</span>
                <span className="qwerty-4">;</span>            
            {"\n"}         
                   {"\n"}     
                <span className="qwerty-6">   switch </span>
                <span className="qwerty-4">(</span>
                <span className="qwerty-5">i</span>
                <span className="qwerty-4">) </span>
            {"\n"}
                <span className="qwerty-4" >   &#123; </span>
            {"\n"}          
            <span className="qwerty-3">    case </span>
                <span className="qwerty-1">10</span>
                <span className="qwerty-4">:</span>            
            {"\n"}
            <span className="qwerty-8">    printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">My case is 10\n</span>
                <span className="qwerty-4">");</span>
            {"\n"}
            <span className="qwerty-5">    break</span>
                <span className="qwerty-4">;</span>            
            {"\n"}
            <span className="qwerty-3">    case </span>
                <span className="qwerty-1">20</span>
                <span className="qwerty-4">:</span>            
            {"\n"}
            <span className="qwerty-8">    printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">My case is 20 \n</span>
                <span className="qwerty-4">");</span>
            {"\n"}
            <span className="qwerty-5">    break</span>
                <span className="qwerty-4">;</span>            
            {"\n"}
            <span className="qwerty-3">    case </span>
                <span className="qwerty-1">40</span>
                <span className="qwerty-4">:</span>            
            {"\n"}
            <span className="qwerty-8">    printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">My case is 40 \n</span>
                <span className="qwerty-4">");</span>
            {"\n"}
            <span className="qwerty-5">    break</span>
                <span className="qwerty-4">;</span>            
            {"\n"}
            <span className="qwerty-3">    default</span>
                <span className="qwerty-4">:</span>            
            {"\n"}
            <span className="qwerty-8">    printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">This is a default no \n</span>
                <span className="qwerty-4">");</span>
            {"\n"}                     
                  <span className="qwerty-4" >   &#125;</span>       
            {"\n"}                   
            <span className="qwerty-7">   return</span>
                <span className="qwerty-3"> 0</span>
                <span className="qwerty-4">; </span>
            {"\n"}            
                <span className="qwerty-4"> &#125;</span>
                {"\n"}      {"\n"} 
                 </code>
        </pre>
        </div>
        <h4 className='headings'>Output :</h4>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
          <pre style={{maxHeight:"100vh"}}>
                <code >                  
                {"\n"}      
                  <span className="qwerty-5">My case is</span>                   
                  <span className="qwerty-1"> 20</span>                   
                     {"\n"} 
                     {"\n"} 
                  </code>
                  </pre>
                  </div>   

<h2 className="mt-4 mh2">Char values in switch case:
</h2>


<h2 className='headings'>Q-Write a program input without user type x in switch case char Values?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
          {"\n"}
          <span className="qwerty-7">#include </span>
                <span className="qwerty-4">&#60;</span>
                <span className="qwerty-10">stdio.h</span>
                <span className="qwerty-4">&#62; </span>
                        {"\n"}
                <span className="qwerty-3">int </span>
                <span className="qwerty-2">main</span>
                <span className="qwerty-4"> ()</span>            
                        {"\n"}   
                        <span className="qwerty-4" > &#123; </span>             
                        {"\n"}
                <span className="qwerty-3">   char </span>
                <span className="qwerty-5">x</span>
                <span className="qwerty-4">="</span>            
                <span className="qwerty-5">d</span>
                <span className="qwerty-4">";</span>            
                            {"\n"} 
                   {"\n"}     
                <span className="qwerty-6">   switch </span>
                <span className="qwerty-4">(</span>
                <span className="qwerty-5">x</span>
                <span className="qwerty-4">) </span>
            {"\n"}
                <span className="qwerty-4" >   &#123; </span>
            {"\n"}          
            <span className="qwerty-3">    case </span>
                <span className="qwerty-4">'</span>            
                <span className="qwerty-1">b</span>
                <span className="qwerty-4">'</span>            
                <span className="qwerty-4">:</span>            
            {"\n"}
            <span className="qwerty-8">    printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">case b \n</span>
                <span className="qwerty-4">");</span>
            {"\n"}
            <span className="qwerty-5">    break</span>
                <span className="qwerty-4">;</span>            
            {"\n"}
            <span className="qwerty-3">    case </span>
                <span className="qwerty-4">'</span>            
                <span className="qwerty-1">d</span>
                <span className="qwerty-4">'</span>            
                <span className="qwerty-4">:</span>            
            {"\n"}
            <span className="qwerty-8">    printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">case d \n</span>
                <span className="qwerty-4">");</span>
            {"\n"}
            <span className="qwerty-5">    break</span>
                <span className="qwerty-4">;</span>            
            {"\n"}
            <span className="qwerty-3">    case </span>
                <span className="qwerty-4">'</span>            
                <span className="qwerty-1">f</span>
                <span className="qwerty-4">'</span>            
                <span className="qwerty-4">:</span>            
            {"\n"}
            <span className="qwerty-8">    printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">case f \n</span>
                <span className="qwerty-4">");</span>
            {"\n"}
            <span className="qwerty-5">    break</span>
                <span className="qwerty-4">;</span>            
            {"\n"}
            <span className="qwerty-3">    default</span>
                <span className="qwerty-4">:</span>            
            {"\n"}
            <span className="qwerty-8">    printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">I am in default</span>
                <span className="qwerty-4">");</span>
            {"\n"}                     
                  <span className="qwerty-4" >   &#125;</span>       
            {"\n"}                   
            <span className="qwerty-7">   return</span>
                <span className="qwerty-3"> 0</span>
                <span className="qwerty-4">; </span>
            {"\n"}            
                <span className="qwerty-4"> &#125;</span>
                {"\n"}      {"\n"} 
                 </code>
        </pre>
        </div>
        <h4 className='headings'>Output :</h4>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
          <pre style={{maxHeight:"100vh"}}>
                <code >                  
                {"\n"}      
                  <span className="qwerty-5">case</span>                   
                  <span className="qwerty-1"> d</span>                   
                  {"\n"}                
                     {"\n"} 
                  </code>
                  </pre>
                  </div>    

<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/c-if-else-if">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-looping">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Cswitch;